import { useState, useEffect } from 'react'
import { CheckCircle2, AlertTriangle, HelpCircle } from 'lucide-react'

// Sistema GLOBAL de modais elegantes (sucesso / erro / confirmação) — sem alert/confirm nativo.
// Uso em qualquer lugar:  successModal('...')  ·  errorModal('...')  ·  await confirmModal('...')
let _open = null

export function successModal(message, opts = {}) {
  return new Promise((resolve) => (_open ? _open({ kind: 'success', message, ...opts, resolve }) : resolve(true)))
}
export function errorModal(message, opts = {}) {
  return new Promise((resolve) => (_open ? _open({ kind: 'error', message, ...opts, resolve }) : resolve(true)))
}
export function confirmModal(message, opts = {}) {
  return new Promise((resolve) => (_open ? _open({ kind: 'confirm', message, ...opts, resolve }) : resolve(window.confirm(message))))
}

export function UIHost() {
  const [dlg, setDlg] = useState(null)
  useEffect(() => { _open = (d) => setDlg(d); return () => { _open = null } }, [])
  if (!dlg) return null

  const close = (val) => { const r = dlg.resolve; setDlg(null); r && r(val) }
  const isConfirm = dlg.kind === 'confirm'
  const danger = dlg.kind === 'error' || dlg.danger
  const theme = danger
    ? { ring: 'from-red-100 to-rose-100', icon: 'text-red-600', Icon: AlertTriangle, btn: 'from-red-500 to-red-600' }
    : isConfirm
      ? { ring: 'from-primary-100 to-accent-100', icon: 'text-accent-600', Icon: HelpCircle, btn: 'from-primary-500 to-accent-500' }
      : { ring: 'from-emerald-100 to-teal-100', icon: 'text-emerald-600', Icon: CheckCircle2, btn: 'from-primary-500 to-accent-500' }
  const title = dlg.title || (dlg.kind === 'success' ? 'Tudo certo!' : dlg.kind === 'error' ? 'Ops!' : 'Confirmar')

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => !isConfirm && close(true)} />
      <div className="relative w-full max-w-sm bg-white rounded-2xl shadow-2xl overflow-hidden tc-pop">
        <div className="p-6 text-center">
          <div className={`w-16 h-16 mx-auto rounded-full bg-gradient-to-br ${theme.ring} flex items-center justify-center mb-4`}>
            <theme.Icon size={32} className={theme.icon} strokeWidth={2.2} />
          </div>
          <h3 className="text-lg font-heading font-bold text-gray-900">{title}</h3>
          {dlg.message && <p className="text-sm text-gray-500 mt-1.5 whitespace-pre-wrap leading-relaxed">{dlg.message}</p>}
        </div>
        <div className="px-6 pb-6 flex gap-2 justify-center">
          {isConfirm && (
            <button onClick={() => close(false)} className="px-5 py-2.5 rounded-xl border border-gray-200 text-gray-600 text-sm font-semibold hover:bg-gray-50 transition-colors">
              {dlg.cancelLabel || 'Cancelar'}
            </button>
          )}
          <button autoFocus onClick={() => close(true)} className={`px-6 py-2.5 rounded-xl bg-gradient-to-r ${theme.btn} text-white text-sm font-bold shadow-md hover:brightness-95 transition-all`}>
            {dlg.okLabel || (isConfirm ? 'Confirmar' : 'OK')}
          </button>
        </div>
      </div>
    </div>
  )
}
